export const defaultGtm = () => ({
    submit: {
        event: 'fac_button_click',
        category: 'vuejs-funil-vendas',
        action: 'click',
        label: 'Salvar - Alterar Etapa e Status'
    },
    cancel: {
        event: 'fac_button_click',
        category: 'vuejs-funil-vendas',
        action: 'click',
        label: 'Cancelar - Alterar Etapa e Status'
    }
})